"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridTradingCalcProfitPerGrid = exports.GridTradingCalcProfitPerGridOnGeometric = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
function getGridSingleProfit(lowParam, highParam, numberParam, feeRate, pricePrecision) {
    if (!Number(highParam) ||
        !Number(lowParam) ||
        !Number(numberParam) ||
        Number(lowParam) >= Number(highParam) ||
        Number(numberParam) < 2) {
        return [0, 0];
    }
    const high = new trade_utils_lib_1.SafeDecimal(highParam);
    const low = new trade_utils_lib_1.SafeDecimal(lowParam);
    const count = new trade_utils_lib_1.SafeDecimal(numberParam);
    const precision = Number(pricePrecision || 0);
    const priceStep = high.sub(low).div(count.sub(1));
    let priceBelow = new trade_utils_lib_1.SafeDecimal(0);
    let minProfit = new trade_utils_lib_1.SafeDecimal(0);
    let maxProfit = new trade_utils_lib_1.SafeDecimal(0);
    const fee = new trade_utils_lib_1.SafeDecimal(feeRate);
    // 轮训是为了解决因为精度问题导致的格子区间不稳定状态。
    for (let i = 0; i < count.toNumber(); i++) {
        const price = low.add(priceStep.mul(i)).toDecimalPlaces(precision, trade_utils_lib_1.SafeDecimal.ROUND_FLOOR);
        // 当第一次i === 0 的时候，priceBelow没有值为0
        if (priceBelow.greaterThan(0)) {
            // (price * (1 - feeRateDecimal) - priceBelow * (1 + feeRateDecimal)) / priceBelow;
            const profit = price
                .mul(new trade_utils_lib_1.SafeDecimal(1).sub(fee))
                .sub(priceBelow.mul(new trade_utils_lib_1.SafeDecimal(1).add(fee)))
                .div(priceBelow);
            // 赋值默认值
            if (i <= 1) {
                maxProfit = profit;
                minProfit = profit;
            }
            if (profit.greaterThan(maxProfit)) {
                maxProfit = profit;
            }
            if (profit.lessThan(minProfit)) {
                minProfit = profit;
            }
        }
        priceBelow = price;
    }
    return [minProfit.toNumber(), maxProfit.toNumber()];
}
// 不处理精度, 仅仅用来计算
function GridTradingCalcProfitPerGridOnGeometric(top, bottom, count, fee) {
    if (!Number(top) || !Number(bottom) || !Number(count) || Number(count) < 2) {
        return 0;
    }
    const _fee = Number(fee) || 0;
    //Math.pow(top/bottom, 1/(gridCount - 1)) - (1 + 手续费率*2)
    const _top = new trade_utils_lib_1.SafeDecimal(top);
    const _bottom = new trade_utils_lib_1.SafeDecimal(bottom);
    const _count = new trade_utils_lib_1.SafeDecimal(count);
    const _feeRate = new trade_utils_lib_1.SafeDecimal(_fee);
    const result = trade_utils_lib_1.SafeDecimal.pow(_top.div(_bottom), new trade_utils_lib_1.SafeDecimal(1).div(_count.sub(1))).sub(_feeRate.mul(2).add(1));
    return result.toNumber();
}
exports.GridTradingCalcProfitPerGridOnGeometric = GridTradingCalcProfitPerGridOnGeometric;
/**
 * 处理精度, 用来展示
 * @param gridType
 * @param top
 * @param bottom
 * @param count
 * @param fee
 * @param pricePrecision 此为必传，但是兼容其他版本写了默认值
 * @returns
 */
function GridTradingCalcProfitPerGrid(gridType, top, bottom, count, fee, pricePrecision) {
    if (!Number(top) || !Number(bottom) || !Number(count)) {
        return undefined;
    }
    if (gridType === "arithmetic") {
        return getGridSingleProfit(bottom, top, count, fee, pricePrecision).map((value, index, array) => {
            return new trade_utils_lib_1.SafeDecimal(value).toDecimalPlaces(8, trade_utils_lib_1.SafeDecimal.ROUND_FLOOR).toNumber();
        });
    }
    else {
        const result = GridTradingCalcProfitPerGridOnGeometric(top, bottom, count, fee);
        return [new trade_utils_lib_1.SafeDecimal(result).toDecimalPlaces(8, trade_utils_lib_1.SafeDecimal.ROUND_FLOOR).toNumber()];
    }
}
exports.GridTradingCalcProfitPerGrid = GridTradingCalcProfitPerGrid;
